// Shared scroll helpers for the unit-page topic nav. Both unitPage.js (legacy
// nav) and unitPageDigital.js (digital nav) use these verbatim; the packs differ
// in their scroll offsets and sticky-element strategy, which stay pack-local.

export function getOffset(element) {
  const rect = element.getBoundingClientRect();
  return {
    top: rect.top + window.pageYOffset,
    left: rect.left + window.pageXOffset,
  };
}

// Given a sorted [{ selector, offsetTop }] map and a scroll position, return the
// anchor whose section the viewport is currently within.
export function findActiveAnchor(anchorMap, position) {
  return anchorMap.find((a, idx) => {
    const next = anchorMap[idx + 1];

    const adjustedPosition = position;
    const offset = position + window.innerHeight;

    // if at bottom of page return the last
    if (offset >= document.documentElement.offsetHeight) {
      return idx === anchorMap.length - 1;
    }
    // if before first, return first
    else if (adjustedPosition < anchorMap[0].offsetTop) {
      return idx === 0;
    }
    // if inbetween return it
    else if (next) {
      return a.offsetTop <= adjustedPosition && adjustedPosition < next.offsetTop;
    }
    // otherwise return the last
    return idx === anchorMap.length - 1;
  });
}
